import { render, staticRenderFns } from "./tabs.vue?vue&type=template&id=c16ac840&scoped=true&"
import script from "./tabs.vue?vue&type=script&lang=js&"
export * from "./tabs.vue?vue&type=script&lang=js&"
import style0 from "./tabs.vue?vue&type=style&index=0&id=c16ac840&prod&lang=css&"
import style1 from "./tabs.vue?vue&type=style&index=1&id=c16ac840&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c16ac840",
  null
  
)

export default component.exports